<template>
<div id="lineas-captura-admin">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Activo Fijo Nacional" class="elevation-1 px-5 py-3">
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab :key="'in-expedientes'">Expedientes</v-tab>
                        <v-tab :key="'in-zip'">Carga Zip</v-tab>
                        <v-tab-item :key="'in-expedientes'">
                            <v-container fluid fill-height>
                                <v-layout align-center justify-center>
                                    <v-flex xs12>
                                        <v-card>
                                            <v-card-text>
                                                <v-card-actions>
                                               
                                                <v-spacer></v-spacer>
                                                <v-speed-dial id="descargos_sd" direction="left" open-on-hover>
                                                            <template v-slot:activator>
                                                                <v-btn id="descargos_sd_btn" x-small fab dark color="primary" >
                                                                    <v-icon>reorder</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <exportar-excel :data="camposLayout" :exportFields="encabezadoLayout" name="Layout_AFNacionalFacturas.xlsx" >
                                                                    <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout CFDI's" v-tippy>
                                                                        <v-icon dark>receipt</v-icon>
                                                                    </v-btn>
                                                                </exportar-excel>
                                                                <upload-excel-component idInput="pedimentosKey" :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                    </v-speed-dial>
                                                </v-card-actions>
                                                <div id="datagrid">
                                                    <v-refresh-button :funcion="cargarConsultas" />
                                                    <v-client-table ref="vuetable" :data="consulta.items" :columns="consulta.columns" :options="consulta.options" class="elevation-2 pa-2">
                                                        <template slot="noResults">
                                                            <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                                                        </template>
                                                        <template slot="cfdis" slot-scope="props" class="text-end">
                                                           <span>{{ props.row.cfdis.length }}</span>
                                                       </template>
                                                       <template slot="adjuntos" slot-scope="props" style="text-align:center">
                                                           <span>{{ props.row.adjuntos != undefined ?props.row.adjuntos.length:0 }}</span>
                                                       </template>
                                                        <template slot="actions" slot-scope="props">
                                                           <v-btn  color="blue" x-small fab  dark @click.native="ver(props.row.id)" title="Consultar Expediente" v-tippy>
                                                               <v-icon >search</v-icon>
                                                          </v-btn>
                                                          <v-btn btn color="red" x-small fab dark  @click.native="eliminar(props.row._id, props.row.id)" title="Eliminar Expediente" v-tippy>
                                                               <v-icon >delete</v-icon>
                                                          </v-btn>
                                                       </template>
                                                    </v-client-table>
                                                </div>

                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item :key="'in-zip'">
                            <v-container fluid fill-height>
                                <v-layout align-center justify-center>
                                    <v-flex xs12>
                                        <v-card>
                                        <v-card-text>
                                            <v-form ref="form" lazy-validation>
                                                <v-container grid-list-md>
                                                    <v-layout wrap>
                                                        <p class="text-justify" >
                                                            <v-icon color="indigo" >info</v-icon>                                            
                                                            <strong>El nombre del archivo ZIP quedara definido como el identificador del expediente</strong>
                                                           </p>

                                                        <v-flex xs12>
                                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-form>
                                        </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                      
                 
                    </v-tabs>

               

                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>


</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
        loader: GridLoader
    },
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("usuario");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.permisoEliminar = true;
            this.model.rfc = "ADMINISTRACION";
            this.get_rfcs();
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
        }

     
        this.cargarConsultas();
    },
    data: () => ({
        file: "",
        file_adjunto: null,
        apivucem: "https://apivucem.econnectpro.mx",
        name_file: "",
        size_file: 0,
        type_file: 'application/zip',
        rfcs_array: [],
        show_combo_rfc: false,
        dialog1: false,
        lista_filtrada: [],
        refreshTabla: false,
        permisoEliminar: false,
        fab: false,
        elzip: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/admin"
            },
            {
                text: "Contribuciones",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
     
        modal: false,
        validaContribucion: false,
        validaForma: false,
        validaIdentificador: false,
        arr_formas_pago: [],
        arr_contribuciones: [],

        show_loading: true,

        consulta: {
            columns: ["id", "fecha", "usuario", "cfdis", "adjuntos", 'actions'],
            options: {
                filterable: ["id", "fecha", "usuario"],
                sortable: ["id", "fecha", "usuario"],

                headings: {
                    id: "No. Proceso",
                    fecha_creacion: "Fecha Solicitud",
                    usuario: "Usuario",
                    cfdis: "Facturas Relacionadas",
                    adjuntos: "Archivos Adjuntos",
                    actions: "Opciones"
                }
            },
            selected: [],
            camposexcel: {
                "Banco": "banco",
                "Referencia": "referencia",
                "Importe": "efectivo",
                "Fecha de Cargo": "fecha",
                "Estatus": "estatus"
            },
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                rfc: "rfc",
                banco: "banco",
                linea: "linea",
                otros: "otros",
                importe: "importe",
                fecha: "fecha",
                aduana: "aduana",
                patente: "patente",
                pedimento: "pedimento",
                numero_operacion_bancaria: "numero_operacion_bancaria",
                numero_transaccion_sat: "numero_transaccion_sat",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                rfc: "[RFC]",
                banco: "[Banco]",
                linea: "[Línea de Captura 20 caracteres, ejemplo: 032001AJO6P127331222]",
                otros: "[Otras referencias de Pago]",
                importe: "[Importe]",
                fecha: "[Fecha de Cargo]",
                aduana: "[Numero de aduana 2 digitos]",
                patente: "[Número de Patente 4 dígitos]",
                pedimento: "[Número de Pedimento 7 dígitos]",
                numero_operacion_bancaria: "[Número operación bancaria - Opcional]",
                numero_transaccion_sat: "[Número Transaccion SAT - Opcional]",
            }]
        },
        model: {
            rfc: "",
            rfc_cliente: "",
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            reporte_url: "",
            nombre_reporte: "",
            tipo: "Layout_Contribuciones",
            lista: '',
        },

        menu1: false,
        menu2: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        importData: [],
        encabezadoLayout: {
            "proceso":"proceso",
            "rfc": "rfc",
            "folio_fiscal": "folio_fiscal",
            "folio":"folio",
            "serie":"serie",
            "fecha": "fecha",
            "efecto_comprobante": "efecto_comprobante",
            "secuencia_factura": "secuencia_factura",
            "cantidad": "cantidad",
            "unidad": "unidad",
            "numero_identificacion":"numero_identificacion",
            "descripcion": "descripcion",
            "moneda":"moneda",
            "precio_unitario": "precio_unitario",
            "importe": "importe",
            "iva": "iva",
            "total": "total",
            "tipo_cambio": "tipo_cambio",
            "metodo_pago": "metodo_pago",
            "numero_certificado": "numero_certificado"
        },
    //    RFC	FOLIO FISCAL	FOLIO Y SERIE	FECHA	LUGAR	EFECTO DE COMPROBANTE	SECUENCIA FACTURA	CANTIDAD	UNIDAD	NÚMERO DE IDENTIFICACIÓN	DESCRIPCIÓN	MONEDA	PRECIO UNITARIO	IMPORTE	IVA	TOTAL	TIPO DE CAMBIO	MÉTODO DE PAGO	NÚMERO DE SERIE DEL CERTIFICADO SAT
        camposLayout: [{
            "proceso":"[ No. Proceso ]",
            "rfc":"[ RFC ]",
            "folio_fiscal": "[ Folio Fiscal ]",
            "folio":"[ Folio ]",
            "serie":"[ Serie ]",
            "fecha":"[ Fecha ]",
            "efecto_comprobante":"[ Efecto Comprobante ]",
            "secuencia_factura":"[ Secuencia Factura ]",
            "cantidad":"[ Cantidad ]",
            "unidad":"[ Unidad ]",
            "numero_identificacion":"[ No. Identificación ]",
            "descripcion": "[ Descripción ]",
            "moneda":"[ Moneda ]",
            "precio_unitario":"[ Precio Unitario ]",
            "importe":"[ Importe ]",
            "iva":"[ IVA ]",
            "total":"[ Total ]",
            "tipo_cambio":"[ Tipo Cambio ]",
            "metodo_pago":"[ Metodo Pago ]",
            "numero_certificado":"[ No. Certificado ]"

        }],
        camposObligatorios: [
            "proceso",
            "rfc",
            "folio_fiscal",
            "folio",
            "serie",
            "fecha",
            "efecto_comprobante",
            "secuencia_factura",
            "cantidad",
            "unidad",
            "numero_identificacion",
            "descripcion",
            "moneda",
            "precio_unitario",
            "importe",
            "iva",
            "total",
            "tipo_cambio",
            "metodo_pago",
            "numero_certificado"
        ],
    }),

    methods: {
        pickFile() {
            this.$refs.file_input.click()
        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                                        
                   

                    var nombre = this.name_file.split(".");
                    var split = [];
                   
                    this.uploadFile(files[0], nombre[0]);                        

                        
                                       

                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },
        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            
          let rfc = this.$local_storage.get("rfc");
        
            var thisObj = this;
 
                    var keyFile = rfc + "/activo_fijo_nacional/" + thisObj.name_file ;
                    
                    var datos = {
                        key: keyFile,
                        bucket: "production.econnect.ds",
                        type: thisObj.type_file
                    }
                    axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                        .then((res) => {
                            if (typeof res.data !== 'undefined') {                        
                                var urlput = res.data.mensaje;
                                //console.log(urlput);
                                axios.put(urlput, file, {headers:{'Content-Type': thisObj.type_file}})
                                .then((res) => {
                                    thisObj.submitFile(referencia, keyFile);    
                                    console.log(keyFile);  
                                                          
                                })                            
                                .catch((error)=>{
                                    thisObj.$root.$dialogLoader.hide();
                                    thisObj.$swal({
                                        type: "error",
                                        title: "¡Operación no Permitida!",
                                        text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                        footer: '',
                                    });
                                    console.log(error);
                                });
                                
                            } else {
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                            }
                        })
                        .catch((error) => {
                            var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                            if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                mensaje = error.response.data.mensaje;
                            thisObj.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: mensaje,
                                footer: '',
                            });
                            console.log(error);
                            thisObj.$root.$dialogLoader.hide();
                        });
                

        },

        submitFile(referencia, keyFile) {   
            let formData = {
                id: referencia,
                key: keyFile,
                rfc: this.$local_storage.get("rfc"),
                usuario: this.$local_storage.get("id_usuario"),
            };
        
                         
            axios.post( this.apivucem + '/activo_fijo/guardar_zip/', formData)                            
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje[0];
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine                
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se está procesando, recibirá una notificación cuando termine.",
                                footer: '',
                            });
                            msg = error.response.data.message;                                
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {                        
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        eliminar: function (id, exp) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el expediente " + exp + " ?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    _id: id,
                }
                axios.post( this.apivucem + '/activo_fijo/eliminar/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El expediente se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el expediente. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarConsultas();
                    });
              }
          });
        },

        setListValues: function () {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada.push(to_list[i]);
                }
            }
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.dialog1 = !this.dialog1;
        },
        ver: function (id) {
            let  rfc= this.$local_storage.get("rfc");
            window.open("/af_nacional/" + rfc + "/" + id, "_blank");
        },
        cargarConsultas: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let formData = {
                rfc: this.$local_storage.get("rfc"),
            };
        
          
            axios.post( this.apivucem + "/activo_fijo/listar/" , formData)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.consulta.items = res.data;
                        this.consulta.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        for (var k in this.consulta.items) {
                            this.consulta.items[k].fecha = this.parseDate(this.consulta.items[k].fecha);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    
        download_layout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
   
   

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
      
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    
        get_rfcs() {
            axios.post("https://apireportes.econnectpro.mx/reportes_ds/get_rfcs_contribuciones/")
                .then(response => {
                    this.rfcs_array = response.data;
                    this.rfcs_array.sort();
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.show_combo_rfc = true;
                });
        },
      
        beforeUpload(file) {
            var self = this;
            const isLt2M = file.size / 1024 / 1024 < 10;

            if (isLt2M) {
                self.file_adjunto = file;
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 10MB.",
                footer: ""
            });
            self.file_adjunto = null;
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        parseDateExcel(excelDate) {
            try {
                if (!excelDate) return false;
                var fecha = '';
                if (excelDate.toString().indexOf('/') != -1 || excelDate.toString().indexOf('-') != -1)
                    fecha = moment(String(excelDate)).format("YYYY-MM-DD");
                else
                    fecha = moment((excelDate - (25567 + 1)) * 86400 * 1000).format("YYYY-MM-DD");
                if (fecha == 'Invalid date') return false;
                return fecha;
            } catch (error) {
                return false;
            }
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            var errorTmp = '';
            const decimalPatron = /^[\d]*(\.{0,1}[\d]*)$/;
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else if (results.length > 5000){
                    errores++;
                    erroresText += "El máximo de filas a procesar es 5000, favor de verificar.";                
                } else {
                    for (var k in results) {                        

                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            
                            results[k]['proceso'] = results[k]['proceso'].toString().trim(); 
                            if(results[k]['proceso'].length > 200){ 
                                errores++;
                                errorTmp = '<br/>' + "- El proceso '" + results[k]['proceso'] + "' no debe tener mas de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['rfc'] = results[k]['rfc'].toString().trim(); 
                            if(results[k]['rfc'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El rfc '" + results[k]['rfc'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['folio_fiscal'] = results[k]['folio_fiscal'].toString().trim(); 
                            if(results[k]['folio_fiscal'].length > 100){ 
                                errores++;
                                errorTmp = '<br/>' + "- El folio_fiscal '" + results[k]['folio_fiscal'] + "' no debe tener mas de 100 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['folio'] = results[k]['folio'].toString().trim(); 
                            if(results[k]['folio'].length > 10){ 
                                errores++;
                                errorTmp = '<br/>' + "- El folio '" + results[k]['folio'] + "' no debe tener mas de 10 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['serie'] = results[k]['serie'].toString().trim();
                            if(results[k]['serie'].length > 10){ 
                                errores++;
                                errorTmp = '<br/>' + "- La serie '" + results[k]['serie'] + "' no debe tener mas de 10 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            let fechaOrig = results[k]["fecha"];
                            results[k]["fecha"] = thisObject.parseDateExcel(fechaOrig);
                            if (results[k]["fecha"] == false) {
                                errores++;
                                errorTmp = '<br/>' + "- La fecha '" + fechaOrig + "' no es una fecha válida.";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['efecto_comprobante'] = results[k]['efecto_comprobante'].toString().trim();
                            if(results[k]['efecto_comprobante'].length > 1 || !["I","E","N"].includes(results[k]['efecto_comprobante'])){ 
                                errores++;
                                errorTmp = '<br/>' + "- El efecto_comprobante '" + results[k]['efecto_comprobante'] + "' no debe tener más de 1 caracter y debe ser I,E ó N";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['secuencia_factura'] = results[k]['secuencia_factura'].toString().trim();
                            if(results[k]['secuencia_factura'].length > 5){ 
                                errores++;
                                errorTmp = '<br/>' + "- La secuencia_factura '" + results[k]['secuencia_factura'] + "' no debe tener mas de 5 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['cantidad'] = results[k]['cantidad'].toString().trim();
                            if(results[k]['cantidad'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- La cantidad '" + results[k]['cantidad'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['cantidad']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- La cantidad '" + results[k]['cantidad'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['unidad'] = results[k]['unidad'].toString().trim();
                            if(results[k]['unidad'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- La unidad '" + results[k]['unidad'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['numero_identificacion'] = results[k]['numero_identificacion'].toString().trim();
                            if(results[k]['numero_identificacion'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El numero_identificacion '" + results[k]['numero_identificacion'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['descripcion'] = results[k]['descripcion'].toString().trim();
                            if(results[k]['descripcion'].length > 200){ 
                                errores++;
                                errorTmp = '<br/>' + "- La descripcion '" + results[k]['descripcion'] + "' no debe tener mas de 200 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['moneda'] = results[k]['moneda'].toString().trim();
                            if(results[k]['moneda'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- La moneda '" + results[k]['moneda'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['metodo_pago'] = results[k]['metodo_pago'].toString().trim();
                            if(results[k]['metodo_pago'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El metodo_pago '" + results[k]['metodo_pago'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['numero_certificado'] = results[k]['numero_certificado'].toString().trim();
                            if(results[k]['numero_certificado'].length > 50){ 
                                errores++;
                                errorTmp = '<br/>' + "- El numero_certificado '" + results[k]['numero_certificado'] + "' no debe tener mas de 50 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['precio_unitario'] = results[k]['precio_unitario'].toString().trim();
                            if(results[k]['precio_unitario'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El precio_unitario '" + results[k]['precio_unitario'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['precio_unitario']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- El precio_unitario '" + results[k]['precio_unitario'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['importe'] = results[k]['importe'].toString().trim();
                            if(results[k]['importe'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El importe '" + results[k]['importe'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['importe']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- El importe '" + results[k]['importe'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['iva'] = results[k]['iva'].toString().trim();
                            if(results[k]['iva'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El iva '" + results[k]['iva'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['iva']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- El iva '" + results[k]['iva'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['total'] = results[k]['total'].toString().trim();
                            if(results[k]['total'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El total '" + results[k]['total'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['total']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- El total '" + results[k]['total'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }
                            results[k]['tipo_cambio'] = results[k]['tipo_cambio'].toString().trim();
                            if(results[k]['tipo_cambio'].length > 20){ 
                                errores++;
                                errorTmp = '<br/>' + "- El tipo_cambio '" + results[k]['tipo_cambio'] + "' no debe tener mas de 20 caracteres";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }else if(!decimalPatron.test(results[k]['tipo_cambio']) ){ 
                                errores++;
                                errorTmp = '<br/>' + "- El tipo_cambio '" + results[k]['tipo_cambio'] + "' no es una cantidad válida";
                                if (erroresText.indexOf(errorTmp) == -1)
                                    erroresText += errorTmp;
                            }                            

                        }
                        
                    }
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
       
        handleSuccess: async function ({
            results,
            header
        }) {            
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {                
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var rfc = this.$local_storage.get("rfc");
                    for (var k in results) {  
                        this.importData.push({  
                            "rfc": results[k]["rfc"].toString(),
                            "folio_fiscal": results[k]["folio_fiscal"].toString(),
                            "folio": results[k]["folio"].toString(),
                            "serie": results[k]["serie"].toString(),
                            "fecha": results[k]["fecha"].toString(),
                            "efecto_comprobante": results[k]["efecto_comprobante"].toString(),
                            "secuencia_factura": results[k]["secuencia_factura"].toString(),
                            "cantidad": results[k]["cantidad"].toString(),
                            "unidad": results[k]["unidad"].toString(),
                            "numero_identificacion": results[k]["numero_identificacion"].toString(),
                            "descripcion": results[k]["descripcion"].toString(),
                            "moneda": results[k]["moneda"].toString(),
                            "precio_unitario": results[k]["precio_unitario"].toString(),
                            "importe": results[k]["importe"].toString(),
                            "iva": results[k]["iva"].toString(),
                            "total": results[k]["total"].toString(),
                            "tipo_cambio": results[k]["tipo_cambio"].toString(),
                            "metodo_pago": results[k]["metodo_pago"].toString(),
                            "numero_certificado": results[k]["numero_certificado"].toString(),
                            "proceso": results[k]["proceso"].toString(),
                        });
                    }
                    var datos = {
                        rfc: rfc,
                        usuario: this.$local_storage.get("id_usuario"), 
                        cfdis: this.importData,
                    }                    
                    
                    axios.post("https://apivucem.econnectpro.mx/activo_fijo/guardar_xls/", datos)                    
                        .then((res) => {
                            
                          //  this.guardar_plantilla_s3(res.data["id_activo_fijo_layout"]);
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El layout se está procesando. Puede recargar los registros para ver su estatus.",
                                footer: ""
                            });

                        })
                        .catch(err => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos. Favor de intentar nuevamente.",
                                footer: ""
                            });                            
                        }).then(() => {
                            this.$root.$dialogLoader.hide();                                                            
                            this.cargarConsultas();                                
                        });
                    
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
    }, //methods
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.elevation-1>>>#VueTables_th--Referencia {
    min-width: 350px !important;
}

.elevation-2>>>#VueTables_th--localizado {
    min-width: 450px !important;
}

.elevation-2>>>.columnaCriterio {
    white-space: normal !important;
    max-width: 450px !important;
    text-align: justify !important;
}
</style>
